import { create } from 'zustand/react'

export type Locale = 'de' | 'en'

export type LocaleState = {
  locale: Locale | undefined
  setLocale: (locale: Locale | undefined) => void
}

export const useLocaleStore = create<LocaleState>((set) => ({
  locale: undefined,
  setLocale: (locale: Locale | undefined) => set((state) => ({ ...state, locale })),
}))
